/**
 * Ctrl/Cmd+F on a campaign view (flow, kanban, table, …) should open
 * the toolbar mission search — unless the user is already typing.
 */
export function isMissionSearchHotkey(e) {
  const target = e.target;
  if (
    target?.tagName === 'INPUT' ||
    target?.tagName === 'TEXTAREA' ||
    target?.isContentEditable
  ) {
    return false;
  }
  return (e.ctrlKey || e.metaKey) && e.key?.toLowerCase() === 'f';
}
